import { CompositionStore } from "./CompositionStore";
import { action } from "mobx";
import { StaticMapStore } from "stores/staticMap/StaticMapStore";
import { FlexModuleModelStore } from "src/stores/FlexModuleModelStore";
import { Logger } from "bernie-logger";
import { SerializedData } from "bernie-core";
import {
  ExtendedContextStore,
  FlexBffTemplateResponse,
  ViewModelResponse,
} from "typings/flexFramework/FlexDefinitions";

export class ServerCompositionStore extends CompositionStore {
  public constructor(state?: SerializedData, logger?: Logger, config?: any) {
    /* istanbul ignore next */
    super(state, logger, config);
  }

  @action
  public setup(
    bffResponse: ViewModelResponse | FlexBffTemplateResponse,
    context: ExtendedContextStore,
    flexModuleModelStore: FlexModuleModelStore,
    mapStore: StaticMapStore
  ) {
    super.setup(bffResponse, context, flexModuleModelStore, mapStore);

    if (this.composition) {
      this.populateFlexModuleModelStoreFromComposition(this.composition);
    }
  }
}
